import PropTypes from 'prop-types'
import React from 'react'

const CardLoading = props => {
  return <div className={`card-loading ${props.className}`}></div>
}

CardLoading.propTypes = {
  className: PropTypes.any
}

export default CardLoading
